/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "./FeatureReduction.js";
import t from "./FeatureReductionCluster.js";
import o from "./FeatureReductionSelection.js";
var s = {
  types: {
    key: "type",
    base: e,
    typeMap: {
      selection: o,
      cluster: t
    }
  },
  json: {
    name: "layerDefinition.featureReduction",
    write: {
      allowNull: !0
    },
    origins: {
      "web-map": {
        types: {
          key: "type",
          base: e,
          typeMap: {
            selection: t
          }
        }
      },
      "web-scene": {
        types: {
          key: "type",
          base: e,
          typeMap: {
            selection: o
          }
        }
      }
    }
  }
};
export { s as featureReductionProperty };